import { useQuery } from "@apollo/client";
import { makeStyles } from "@material-ui/core";
import React from "react";
import {
  Switch,
  Route,
  Redirect,
  useHistory,
  useRouteMatch,
} from "react-router-dom";
import { GET_ACTIVE_USER } from "../../queries/auth.queries";

import Loader from "../common/loader/loader.component";
import AccountMenu from "./account-menu/account-menu.component";
import AccountAddresses from "./account-addresses/account-addresses.component";
import AccountSettings from "./account-settings/account-settings.component";
import OrdersHistoryPage from "../../pages/OrdersHistoryPage/OrdersHistoryPage";
import BankCardsPage from "../../pages/BankCardsPage/BankCardsPage";
import OrderDetailsPage from "../../pages/OrderDetailsPage/OrderDetailsPage";

const useStyles = makeStyles({
  container: {
    paddingTop: 120,
  },
  layout: {
    paddingTop: 12,
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 120,
  },
  menu: {
    width: "15%",
    "@media (max-width:940px)": { display: "none" },
  },
  content: {
    width: "82%",
    maxWidth: 1130,
    paddingBottom: 120,
    "@media (max-width:940px)": { width: "100%" },
  },
});

const Account = () => {
  const classes = useStyles();
  const history = useHistory();
  const { path } = useRouteMatch();

  const { loading, data } = useQuery(GET_ACTIVE_USER);

  if (loading) {
    return (
      <div
        style={{ height: "100vh", display: "flex", justifyContent: "center" }}
      >
        <Loader color="#B73232" size={50} />
      </div>
    );
  }

  if (!data?.activeCustomer) {
    history.push("/");
  }

  return (
    <div className={classes.container}>
      <div className={classes.layout}>
        {/* LEFT SIDEBAR MENU */}
        <div className={classes.menu}>
          <AccountMenu />
        </div>

        {/* RIGHT CONTENT AREA */}
        <div className={classes.content}>
          <Switch>
            <Route
              exact
              path={`${path}/orders`}
              component={OrdersHistoryPage}
            />
            <Route
              exact
              path={`${path}/orders/:id`}
              component={OrderDetailsPage}
            />

            <Route
              exact
              path={`${path}/addresses`}
              component={AccountAddresses}
            />
            <Route
              exact
              path={`${path}/bank-cards`}
              component={BankCardsPage}
            />
            <Route
              exact
              path={`${path}/settings`}
              component={AccountSettings}
            />

            {/* DEFAULT → redirect /account → /account/orders */}
            <Redirect to={`${path}/orders`} />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Account;
